import { type ReactNode } from 'react';

/** The full-page modes lay out per page, so their shell adds nothing. */
export default function HostedPassthroughShell({
  children,
}: {
  children: ReactNode;
}) {
  return <>{children}</>;
}
